import { ActionTypes } from 'constants/index';

export const setPrevPath = (path) => dispatch => {
    dispatch({ type: ActionTypes.SET_PREV_PATH, path });
};

export const emptyPrevPath = () => dispatch => {
    dispatch({ type: ActionTypes.EMPTY_PREV_PATH });
};